import formAdminUsers from './formAdminUsers';

export default {
  title: 'User',
  attributeName: 'users',
  getURL: 'users',
  createURL: 'users',
  updateURL: 'users',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formAdminUsers],
  noArea: true,
  goBack: true,
};
